import { Box, Skeleton, Stack, Typography } from "@mui/material";

import { ErrorTypography } from "components/ErrorTypography";

import { QuestionCard } from "./QuestionCard";

interface QuestionsListProps {
  qaList: QuoteQA[];
  loading: boolean;
  error: string | null;
}

export function QuestionsList({ qaList, loading, error }: QuestionsListProps) {
  if (loading) {
    return <Skeleton variant="rounded" height={80} />;
  }

  if (error) {
    return (
      <Box>
        <ErrorTypography error={error} />
      </Box>
    );
  }

  if (qaList.length === 0) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <Typography variant="body2" color="text.secondary">
          No questions yet. Ask the first question below!
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={2}>
      {qaList.map((qa) => (
        <QuestionCard key={qa.question.id} qa={qa} />
      ))}
    </Stack>
  );
}
